import { render, staticRenderFns } from "./Dog-criador-list.vue?vue&type=template&id=84e0216c&scoped=true&"
import script from "./Dog-criador-list.vue?vue&type=script&lang=js&"
export * from "./Dog-criador-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e0216c",
  null
  
)

export default component.exports